import { useMemo } from 'react';
import { createPath } from 'react-router';
import { pathHasPrefix, useDispatchNavAction } from '@arc/frontend/util-router';
import { defineAbilityFor } from '@arc/shared/util-auth';
const loginPagePath = '/login';
const defaultReturnUrl = '/';
function isOnLoginPage(location) {
  return pathHasPrefix(location.pathname, loginPagePath);
}
export function useRedirectToLogin() {
  const dispatchNavAction = useDispatchNavAction();
  return ({
    noReturn = false
  } = {}) => dispatchNavAction(location => {
    if (isOnLoginPage(location)) return;
    const r = createPath(location);
    return {
      pathname: loginPagePath,
      search: noReturn || r === defaultReturnUrl ? undefined : {
        r
      },
      replace: true,
      state: {
        noBlockNavigation: true
      }
    };
  });
}
export function useRedirectFromLogin(user) {
  const redirect = sessionStorage.getItem('redirect');
  const ability = useMemo(() => defineAbilityFor(user), [user]);
  const dispatchNavAction = useDispatchNavAction();
  return () => dispatchNavAction(location => {
    if (!isOnLoginPage(location)) return;
    if (redirect) return redirect;
    if (ability.can('list', 'Member')) return '/members';
    if (ability.can('list', 'Build')) return '/builds';
    if (ability.can('list', 'Deployment')) return '/deployments';
    if (ability.can('list', 'Job')) return '/jobs';
    return defaultReturnUrl;
  });
}
export function useRedirectFromWelcomePage() {
  const dispatchNavAction = useDispatchNavAction();
  return () => dispatchNavAction(location => {
    if (location.pathname === defaultReturnUrl) return;
    return defaultReturnUrl;
  });
}